"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logic = void 0;
const __1 = require("..");
const create_fn_1 = require("../utils/create-fn");
const get_arg_1 = require("../utils/get-arg");
const exists = (0, create_fn_1.createFn)("fn.logic.exists", (args, context) => {
    const value = (0, get_arg_1.getArgUnknown)(args, 1, context);
    return value !== undefined;
});
const iif = (0, create_fn_1.createFn)("fn.logic.iif", (args, context) => {
    const condition = (0, get_arg_1.getArgUnknown)(args, 1, context);
    if (condition) {
        return (0, get_arg_1.getArgUnknown)(args, 2, context);
    }
    else {
        return (0, get_arg_1.getArgUnknown)(args, 3, context);
    }
});
// Iterates through the arguments if the argument is not an array it will return it
// if the argument is an array it will return the second element if the first element is truthy
// if the first element of the array is falsy it will continue iterating through the arguments
const switchFn = (0, create_fn_1.createFn)("fn.logic.switch", (args, context) => {
    for (const arg of args) {
        if (arg.type === "array") {
            if ((0, __1.execSyntax)(arg.items[0], context)) {
                return (0, __1.execSyntax)(arg.items[1], context);
            }
        }
        else {
            return (0, __1.execSyntax)(arg, context);
        }
    }
    return undefined;
});
exports.logic = {
    exists,
    iif,
    switch: switchFn,
};
//# sourceMappingURL=logic.js.map